<template>
  <div class="vuestic-page-not-found-sad-wallpaper">
    <img src="https://i.imgur.com/hu80UGU.png"
         class="vuestic-page-not-found-sad-wallpaper__sad-image"/>
  </div>
</template>

<script>
export default {
  name: 'VuesticPageNotFoundSadWallpaper',
}
</script>

<style lang="scss">
.vuestic-page-not-found-sad-wallpaper {
  position: absolute;
  overflow: hidden;
  height: 50%;
  width: 30%;
  right: 0;
  bottom: 0;
  padding-left: 0;

  &__sad-image {
    width: 80%;
    height: auto;
    position: absolute;
    padding: 20px 20px 0 20px;
    right: 0;
    bottom: 0;
  }

  @media (max-width: 992px) and (min-width: 840px) {
    overflow: hidden;
    height: 35%;
    padding-left: 0;

    &__sad-image {
      width: 300px;
      height: 240px;
      overflow: hidden;
    }
  }

  @include media-breakpoint-down(xs) {
    display: none;

    &__sad-image {
      display: none;
    }
  }
}
</style>
